import React, {useState, useEffect} from 'react'
import { Outlet,  } from "react-router-dom";
import '../css/body.scss'
import Antes from '../pages/Antes'
import Durante from '../pages/Durante';
import Alllegar from '../pages/Alllegar';
import Footer from '../components/Footer';
import Hero from '../components/Hero';

export default function Body () {
    const [route, setRoute] = useState("lpz-topo");
    const [ship, setShip] = useState("cabo-star");
    const [section, setSection] = useState("antes"); // default

    const routeShips = {
        "lpz-topo": "california-star",
        "topo-lpz": "california-star",
        "lpz-mzt": "cabo-star",
        "mzt-lpz": "cabo-star"
    };

    // CUANDO CAMBIA LA RUTA, CAMBIA EL BARCO
    useEffect(() => {
        setShip(routeShips[route]);
    }, [route]);




    const renderSection = () => {
        switch (section) {
            case "antes":
            return <Antes route={route} />;
            case "durante":
            return <Durante route={route} ship={ship} />;
            case "despues":
            return <Alllegar route={route} />;
            default:
            return <Antes route={route} />;
        }
    };

    const routeContent  = {
        "lpz-topo": {
        titulo: (
            <>
                Viaje de La Paz a <br />
                Topolobampo
            </>),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/xGsosNNDPl4?si=ZVhxy9myH6eCpIrx"
        },
        "topo-lpz": {
        titulo: (
            <>
                Viaje de Topolobampo a <br />
                La Paz
            </>
        ),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/Gj4EAaBK07w?si=5h4PjIJcaHVHW4Av"
        },
        "lpz-mzt": {
        titulo: (
            <>
                Viaje de La Paz a <br />
                Mazatlán
            </>
        ),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/nn7QlS_kEAM?si=Nxk_HhlEbpUCBouE"
        },
        "mzt-lpz": {
        titulo: (
            <>
                Viaje de Mazatlán a <br />
                La Paz
            </>
        ),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/z_UoqPpzs7o?si=m_rSB9rY3QzmGXsH"
        }
    };

    const shipContent = {
        "cabo-star": {
            nombre: "Cabo Star",
            requisitos:
                "Información de embarque para pasajeros del buque Cabo Star.",
            video:
                "https://www.youtube.com/embed/rAzkP8yVMRM?si=vAxaVz6gacR5aWd2"
        },

        "california-star": {
            nombre: "California Star",
            requisitos:
                "Información de embarque para pasajeros del buque California Star.",
            video:
                "https://www.youtube.com/embed/1S4gTYP4dK8?si=L3ZoywJYVo6QI56t"
        }
    };
    const despuesContent  = {
        "lpz-topo": {
        titulo: (
            <>
                Desembarque en <br />
                Topolobampo
            </>),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/UI0zx0nHHSs?si=6n1RKK_2iovxjLjk"
        },
        "topo-lpz": {
        titulo: (
            <>
                Desembarque en <br />
                La Paz
            </>
        ),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/K2bQOI8-dJ0?si=44uJIKLb0Babtmv8"
        },
        "lpz-mzt": {
        titulo: (
            <>
                Desembarque en<br />
                Mazatlán
            </>
        ),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/qwQMdnWI8m4?si=fBQtMOsCODeDEGF7"
        },
        "mzt-lpz": {
        titulo: (
            <>
                Desembarque en <br />
                La Paz
            </>
        ),
        requisitos: "Antes de abordar tu ferry, te invitamos a ver este video informativo donde te mostramos paso a paso el proceso de embarque. Conoce cómo realizar tu documentación, los tiempos recomendados de llegada y las indicaciones necesarias para que tu viaje sea más cómodo, rápido y sin contratiempos.",
        video: "https://www.youtube.com/embed/K2bQOI8-dJ0?si=enfznhiOJgJ8e97y"
        }
    };

    const routeData = routeContent[route];
    const despuesData = despuesContent[route];
    const shipData = shipContent[ship];


    return (
    <>
    <Hero route={route}
        setRoute={setRoute}
        section={section}
        setSection={setSection}
    />
   

    {section === "antes" && (
         <div className='video-section'>
        <div className='container'>
            <div className='content-video'>
                <div className='content-text-video'>           
                    <h2>{routeData?.titulo}</h2>
                    <p>{routeData?.requisitos}</p>
                </div>
                <div className='video-frame'>
                    <iframe width="520" height="315" src={routeData?.video} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>                        
            </div>
        </div>
    </div>
    )}

    {section === "durante" && (
        <div className='video-section'>
            <div className='container'>
                <div className='content-video'>

                    <div className='content-text-video'>
                        <h2>{routeData?.titulo}</h2>
                        <h3>Buque: {shipData?.nombre}</h3>
                        <p>{shipData?.requisitos}</p>
                    </div>

                    <div className='video-frame'>
                        <iframe
                            width="520"
                            height="315"
                            src={shipData?.video}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        ></iframe>
                    </div>

                </div>
            </div>
        </div>
    )}
    
    {section === "despues" && (
         <div className='video-section'>
        <div className='container'>
            <div className='content-video'>
                <div className='content-text-video'>           
                    <h2>{despuesData?.titulo}</h2>
                    <p>{despuesData?.requisitos}</p>
                </div>
                <div className='video-frame'>
                    <iframe width="520" height="315" src={despuesData?.video} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>                        
            </div>
        </div>
    </div>
    )}

    <section className='body'>
                  
        {renderSection()}                                

        {/*<ValoracionAntes />*/}
       
    </section>
    <Footer />
    <Outlet />
    </>
  )
}
